import "./App.css";
import Button from "@mui/material/Button";
import MainPage from "./pages/MainPage";
import PersonalPage from "./pages/PersonalPage";
import Login from "./pages/LoginPage";
import RegPage from "./pages/RegPage";
import ResetPage from "./pages/ResetPage";
import Oferta from "./pages/Oferta";
import { Routes, Route, Link, Outlet, Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LogoutIcon from "@mui/icons-material/Logout";
import { userSlice } from "./redux/user/userSlice";
import PrivateRoute from "./components/PrivateRoute";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Tooltip } from "@mui/material";
import Confidencial from "./pages/Confidencial";
import EmployeeGuidePage from "./pages/EmployeeGuidePage";
import LandingPageNav from "./components/LandingPageNav";

const { exitHandle, resetSelectedProject } = userSlice;

function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<MainPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registration" element={<RegPage />} />
        <Route path="/reset" element={<ResetPage />} />
        <Route path="/reset-password/*" element={<ResetPage />} />
        <Route path="/oferta" element={<Oferta />} />
        <Route path="/politic-confidencial" element={<Confidencial />} />
        <Route path="/dlya-sotrudnika" element={<EmployeeGuidePage />} />
        <Route
          path="/main/*"
          element={
            <PrivateRoute>
              <PersonalPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/" />} />
      </Route>
    </Routes>
  );
}

function Layout() {
  const dispatch = useDispatch();
  const login = useSelector((state) => state.user?.data?.user?.login);
  const { pathname } = useLocation();
  const isLanding = pathname === "/";

  const telegramUsername = "/MoGame_Support";
  const telegramLink = `https://t.me/${telegramUsername}`;

  return (
    <div className="app-layout">
      <header className={`header${isLanding ? " header--landing" : ""}`}>
        <div className="header__brand">
          <Link
            to={login ? "/main" : "/"}
            onClick={() => dispatch(resetSelectedProject())}
            style={{ textDecoration: "none" }}
          >
            <span className="header__logo">InChat</span>
          </Link>
        </div>

        {isLanding ? <LandingPageNav variant="header" /> : null}

        <div className="header__actions">
          {login ? (
            <div className="header__user-bar">
              <div className="header__login">
                <Link
                  to="/main/profile"
                  onClick={() => dispatch(resetSelectedProject())}
                  className="header__login-link"
                >
                  {login}
                </Link>
              </div>
              <Link
                to="/main/price"
                onClick={() => dispatch(resetSelectedProject())}
                className="header__tariffs-link"
              >
                Тарифы
              </Link>
              <Tooltip title="Написать в поддержку" placement="left">
                <div className="support">
                  <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SupportAgentIcon sx={{ color: "white" }} />
                  </a>
                </div>
              </Tooltip>
              <LogoutIcon
                className="header__logout"
                sx={{ cursor: "pointer", color: "white" }}
                onClick={() => dispatch(exitHandle())}
              />
            </div>
          ) : (
            <div className="header__guest-bar">
              <Link to="/main/price" className="header__tariffs-link">
                Тарифы
              </Link>
              <Tooltip title="Написать в поддержку" placement="left">
                <div className="support">
                  <a
                    href={telegramLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <SupportAgentIcon sx={{ color: "white" }} />
                  </a>
                </div>
              </Tooltip>
              <Link to="/login">
                <Button
                  sx={{ bgcolor: "white" }}
                  variant="outlined"
                  size="small"
                >
                  Войти
                </Button>
              </Link>
            </div>
          )}
        </div>
      </header>

      <div className="app-layout__body">
        <Outlet />
      </div>
    </div>
  );
}

export default App;
